import React from 'react';
import { Header } from './../Calculators/Header';
import { Intro } from './../Calculators/Intro';
import { ButtonPanel } from './../Calculators/ButtonPanel';
import { OneColumnLayout } from './../Calculators/Sections';
import { ChartSeries } from './ChartSeries';
import { Button, ButtonLink } from './../Form/index';
import { HousePrice, RepaymentOptions } from './LeftPanel';
import { ClientLoan } from './ClientLoan';

const titleRepayment = [
  'Enter just a few client details to see how partial mortgage repayments and future house',
  'prices may influence the equity your client can retain in their home.'
];

export const PartialRepaymentComponent = ({ screen, partialRepayment, onChangeInput }) => {
  return (
    <div>
      <Header {...screen} title={['Impact of monthly repayments', 'and future house prices']}/>
      {screen.inFrame ? false : <Intro title={titleRepayment} padding={20} />}

      <OneColumnLayout>
        <div className="sidebar">
          <ClientLoan {...partialRepayment} onChangeInput={onChangeInput} />
          <HousePrice {...partialRepayment} onChangeInput={onChangeInput} />
          <RepaymentOptions {...partialRepayment} onChangeInput={onChangeInput} />
        </div>
        <div className="content">
          {/*<DebugSeries series={partialRepayment.output.series} />*/}
          {/*<pre>{JSON.stringify(partialRepayment.input, null, 2)}</pre>*/}
          <ChartSeries {...partialRepayment.output} />
        </div>
      </OneColumnLayout>

      {screen.inFrame ? false : (
        <ButtonPanel className="footer">
          <ButtonLink to='/' style={{ background: 'black' }}>Back</ButtonLink>
          <div style={{ flex: 1 }}></div>
          <Button disabled={true}>Download PDF Report</Button>
        </ButtonPanel>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/PartialRepayment/PartialRepaymentComponent.js